import styled from "styled-components";

export const HomePage = () => {
  return (
    <HomePageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-4">
            <div className="box">
              <div className="box-header">
                <h3 className="box-title">Selamat Datang di Sistem Kerjasama UMN</h3>
              </div>
              <div className="box-body">
                <p>Sistem Kerjasama UMN merupakan sistem yang dibuat untuk mempermudah pencatatan dan pembuatan laporan perjanjian kerjasama antara UMN dengan instansi lainnya. Untuk memulai kegiatan, silahkan pilih salah satu menu di samping.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="box">
              <div className="box-header">
                <h3 className="box-title">Tips</h3>
              </div>
              <div className="box-body">
                <p>Sebelum membuat dokumen kerjasama atau laporan monitor partner, mohon persiapkan data yang dibutuhkan terlebih dahulu melalui menu master data dan partner. Keluar atau menutup halaman dokumen kerjasama akan menyebabkan Anda kehilangan data yang sudah Anda kerjakan.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HomePageWrapper>
  )
}

const HomePageWrapper = styled.div`
  
`;